import { forwardRef, useId, type InputHTMLAttributes } from 'react';
import { inputClass, labelClass } from './authFieldStyles';

type Props = InputHTMLAttributes<HTMLInputElement> & {
  label: string;
  error?: string;
};

export const AuthField = forwardRef<HTMLInputElement, Props>(function AuthField(
  { label, error, id, className = '', ...rest },
  ref,
) {
  const generatedId = useId();
  const inputId = id ?? generatedId;
  return (
    <div>
      <label htmlFor={inputId} className={labelClass}>{label}</label>
      <input ref={ref} id={inputId} className={`${inputClass} ${className}`} {...rest} placeholder={label} />
      {error && <p className="text-red-400 text-xs mt-1.5">{error}</p>}
    </div>
  );
});
